class FilterHandler {
  constructor() {
    this.filterForm = document.querySelector('.filters-form');
    this.sortSelect = document.querySelector('.sort-by');
    this.filterDrawer = document.querySelector('#FilterDrawer');
    this.isSearchPage = window.location.pathname === '/search';
    
    this.init();
  }

  init() {
    // Manejar cambio de ordenamiento
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        this.updateURL({ sort_by: e.target.value });
      });
    }

    // Manejar envío de formulario de filtros
    if (this.filterForm) {
      this.filterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.applyFilters();
      });

      // Aplicar filtros al cambiar checkboxes
      this.filterForm.querySelectorAll('input[type="checkbox"], input[type="number"]').forEach(input => {
        input.addEventListener('change', () => {
          this.applyFilters();
        });
      });
    }

    // Manejar drawer mobile
    this.initMobileDrawer();
  }

  initMobileDrawer() {
    // Abrir drawer
    document.querySelectorAll('.js-drawer-open-filter-drawer').forEach(btn => {
      btn.addEventListener('click', () => {
        this.openDrawer();
      });
    });

    // Cerrar drawer
    document.querySelectorAll('.js-drawer-close').forEach(btn => {
      btn.addEventListener('click', () => {
        this.closeDrawer();
      });
    });

    // Clonar filtros desktop a mobile
    if (this.filterDrawer) {
      const desktopFilters = document.querySelector('.filters-desktop .filters-form');
      if (desktopFilters) {
        const mobileFilters = desktopFilters.cloneNode(true);
        mobileFilters.classList.add('filters-form--mobile');
        this.filterDrawer.querySelector('.filter-drawer__body').appendChild(mobileFilters);
        
        // Re-inicializar eventos para el formulario clonado
        this.initMobileFormEvents(mobileFilters);
      }
    }
  }

  initMobileFormEvents(form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.applyFilters(form);
      this.closeDrawer();
    });

    form.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        this.applyFilters(form);
      });
    });
  }

  openDrawer() {
    if (this.filterDrawer) {
      this.filterDrawer.classList.add('is-open');
      document.body.classList.add('drawer-open');
    }
  }

  closeDrawer() {
    if (this.filterDrawer) {
      this.filterDrawer.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
    }
  }

  applyFilters(form = null) {
    const targetForm = form || this.filterForm;
    const formData = new FormData(targetForm);
    const params = new URLSearchParams(formData);

    // Si estamos en búsqueda, mantener el término de búsqueda
    if (this.isSearchPage) {
      const searchTerm = document.querySelector('input[name="q"]')?.value;
      if (searchTerm) {
        params.set('q', searchTerm);
      }
    }

    // Mantener el sort_by actual
    const currentSort = this.sortSelect?.value;
    if (currentSort) {
      params.set('sort_by', currentSort);
    }

    this.updateURL(params);
  }

  updateURL(params) {
    const url = new URL(window.location);
    
    if (params instanceof URLSearchParams) {
      // Reemplazar todos los parámetros
      url.search = params.toString();
    } else {
      // Actualizar parámetros específicos
      Object.keys(params).forEach(key => {
        url.searchParams.set(key, params[key]);
      });
    }

    // Hacer petición AJAX o recargar página
    if (window.theme?.ajaxCart) {
      this.fetchFilteredProducts(url.toString());
    } else {
      window.location.href = url.toString();
    }
  }

  async fetchFilteredProducts(url) {
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');

      // Actualizar grid de productos
      const productGrid = this.isSearchPage 
        ? document.querySelector('#main-search-product-grid')
        : document.querySelector('#main-collection-product-grid');
        
      const newProductGrid = this.isSearchPage
        ? newDocument.querySelector('#main-search-product-grid')
        : newDocument.querySelector('#main-collection-product-grid');

      if (productGrid && newProductGrid) {
        productGrid.innerHTML = newProductGrid.innerHTML;
      }

      // Actualizar contador de productos
      const productCount = newDocument.querySelector('.filters-toolbar__product-count');
      if (productCount) {
        document.querySelector('.filters-toolbar__product-count').textContent = productCount.textContent;
      }

      // Actualizar paginación
      const pagination = newDocument.querySelector('.pagination');
      const currentPagination = document.querySelector('.pagination');
      if (pagination && currentPagination) {
        currentPagination.innerHTML = pagination.innerHTML;
      }

      // Re-inicializar eventos de cantidad si es necesario
      if (window.theme?.initQuantityButtons) {
        window.theme.initQuantityButtons();
      }

    } catch (error) {
      console.error('Error al filtrar productos:', error);
      window.location.href = url;
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new FilterHandler();
});